/* eslint-disable react/no-unescaped-entities */
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import Container from "components/Container";

const FullScreenHeroWithLogoGrid = () => {
  const theme = useTheme();
  return (
    <Box
      minHeight={"100vh"}
      display={"flex"}
      alignItems={"center"}
      sx={{
        backgroundImage: "url('ABF 2024-124.jpg')",
        backgroundColor: "rgba(255, 255, 255, 0.4)", // Grey overlay
        backgroundBlendMode: "overlay",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Grid container >
          <Grid item xs={12}>
            <Box
              width="100%"
              height="100%"
              display="flex"
              justifyContent={"center"}
            >
              <Box>
                <Typography
                  variant="h3"
                  align={"center"}
                  gutterBottom
                  sx={{
                    fontWeight: 900,
                  }}
                >
                  Acro Beach Festival
                </Typography>
                <Typography
                  variant="h6"
                  component="p"
                  color="text.secondary"
                  align={"center"}
                  sx={{
                    fontWeight: 600,
                  }}
                >
                  14 mai au 17 mai 2026 <br></br>Espace vert de la barre Anglet <br></br>
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default FullScreenHeroWithLogoGrid;
